// root-reducer.js
import * as actionKeys from './action-keys';

const DEFAULT_STATE = {
    insurances: [],
    additionalInfo: '',
    name: '',
    address: '',
    mobile: '',
    email: '',
    contactOption: '',
    contactDateTimeOption: '',
    contactDate: '',
    contactTime: '',
    minimal: false
};

export const rootReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actionKeys.SET_INSURANCES:
            return {
                ...state,
                insurances: action.payload
            };

        case actionKeys.ADD_INSURANCE:
            return {
                ...state,
                insurances: state.insurances.concat(action.payload)
            };

        case actionKeys.REMOVE_INSURANCE:
            return {
                ...state,
                insurances: state.insurances.filter((name) => name !== action.payload)
            };

        case actionKeys.SET_ADDITIONAL_INFO:
            return {
                ...state,
                additionalInfo: action.payload
            };

        case actionKeys.SET_NAME:
            return {
                ...state,
                name: action.payload
            };

        case actionKeys.SET_BIRTHDATE:
            return {
                ...state,
                birthdate: action.payload
            };

        case actionKeys.SET_ADDRESS:
            return {
                ...state,
                address: action.payload
            };

        case actionKeys.SET_ADDRESS_VALID:
            return {
                ...state,
                isAddressValid: action.payload
            };

        case actionKeys.SET_MOBILE:
            return {
                ...state,
                mobile: action.payload
            };

        case actionKeys.SET_EMAIL:
            return {
                ...state,
                email: action.payload
            };

        case actionKeys.SET_CONTACT_OPTION:
            return {
                ...state,
                contactOption: action.payload
            };

        case actionKeys.SET_CONTACT_DATE_TIME_OPTION:
            return {
                ...state,
                contactDateTimeOption: action.payload
            };

        case actionKeys.SET_CONTACT_DATE:
            return {
                ...state,
                contactDate: action.payload
            };

        case actionKeys.SET_CONTACT_TIME:
            return {
                ...state,
                contactTime: action.payload
            };

        case actionKeys.SET_MINIMAL:
            return {
                ...state,
                minimal: action.payload
            };

        default:
            return state;
    }
};

export default rootReducer;
